import PropTypes from 'prop-types';
import React from 'react';
import { Modal, ModalHeader } from 'reactstrap';
import ChecksListView from './checksListView';
import GenerateChecksView from './generateChecksView';
import useChecksSettings from './useChecksSettings';

// Checks Settings Modal component
const ChecksSettingsModal = _ref => {
  let isOpen = _ref.isOpen,
    onClose = _ref.onClose,
    _ref$checksCollection = _ref.checksCollection,
    checksCollection = _ref$checksCollection === void 0 ? {} : _ref$checksCollection,
    _ref$defaultChecks = _ref.defaultChecks,
    defaultChecks = _ref$defaultChecks === void 0 ? {} : _ref$defaultChecks,
    path = _ref.path,
    formActions = _ref.formActions,
    reduxEntity = _ref.reduxEntity,
    _ref$content = _ref.content,
    content = _ref$content === void 0 ? null : _ref$content,
    notificationActions = _ref.notificationActions,
    _ref$pendingOperation = _ref.pendingOperation,
    pendingOperation = _ref$pendingOperation === void 0 ? false : _ref$pendingOperation;
  const _useChecksSettings = useChecksSettings({
      checksCollection,
      defaultChecks,
      path,
      formActions,
      reduxEntity,
      content,
      notificationActions,
      pendingOperation,
      onClose
    }),
    currentView = _useChecksSettings.currentView,
    checksArray = _useChecksSettings.checksArray,
    userRequest = _useChecksSettings.userRequest,
    setUserRequest = _useChecksSettings.setUserRequest,
    isGenerating = _useChecksSettings.isGenerating,
    suggestions = _useChecksSettings.suggestions,
    addingId = _useChecksSettings.addingId,
    handleToggle = _useChecksSettings.handleToggle,
    handleDelete = _useChecksSettings.handleDelete,
    handleGenerateClick = _useChecksSettings.handleGenerateClick,
    handleAddSuggestion = _useChecksSettings.handleAddSuggestion,
    handleClose = _useChecksSettings.handleClose,
    handleNavigateToGenerate = _useChecksSettings.handleNavigateToGenerate,
    handleNavigateToList = _useChecksSettings.handleNavigateToList;
  return /*#__PURE__*/React.createElement(Modal, {
    isOpen: isOpen,
    toggle: handleClose,
    size: "lg"
  }, currentView === 'list' ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(ModalHeader, {
    toggle: handleClose
  }, "Quality Agent Settings"), /*#__PURE__*/React.createElement(ChecksListView, {
    checksArray: checksArray,
    onToggle: handleToggle,
    onDelete: handleDelete,
    onGenerateClick: handleNavigateToGenerate,
    onClose: handleClose
  })) : /*#__PURE__*/React.createElement(GenerateChecksView, {
    userRequest: userRequest,
    onUserRequestChange: setUserRequest,
    isGenerating: isGenerating,
    suggestions: suggestions,
    addingId: addingId,
    onGenerate: handleGenerateClick,
    onAddSuggestion: handleAddSuggestion,
    onBack: handleNavigateToList,
    pendingOperation: pendingOperation
  }));
};
ChecksSettingsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  checksCollection: PropTypes.shape({}),
  defaultChecks: PropTypes.shape({}),
  path: PropTypes.string.isRequired,
  formActions: PropTypes.shape({
    change: PropTypes.func.isRequired,
    handleActions: PropTypes.func
  }).isRequired,
  reduxEntity: PropTypes.string.isRequired,
  content: PropTypes.shape({
    title: PropTypes.string,
    formType: PropTypes.shape({
      name: PropTypes.string
    })
  }),
  notificationActions: PropTypes.shape({
    info: PropTypes.func.isRequired
  }).isRequired,
  pendingOperation: PropTypes.bool
};
export default ChecksSettingsModal;